import React from 'react'
import filterConfig from '../../program-section-types-config.json'
import Program from './Program'
import CollectionsListContainer from '../../containers/PageEditSelection/CollectionsListContainer'
import SaveStateButton from '../general/SaveStateButton'
import { PERIOD } from '../../constants/programSectionTypes.js'
import { HIGHLIGHT } from '../../constants/itemTypes.js'
import WrapperPageEditSelectionTitleContainer from '../WrapperPage/cont/WrapperPageEditSelectionTitleContainer'
import RequestOverlayContainer from '../overlay/container/RequestOverlayContainer'
import Translation from '../Translation/cont/Translation'
import OverlayEditSelectionContainer from '../overlay/container/OverlayEditSelectionContainer'
import requestStatus from '../../constants/requestStatus'
import ListToogleAllButtons from '../DragAndDropList/presents/ListToogleAllButtons.jsx'

const SelectionPage =({
    selectionId,
    selectionType, 
    selection,
    displayDropzones, 
    displayMovies, 
    displayAds, 
    displayAdvertisements,
    displayHighlights, 
    displayWeischer,
    closePagePath,
    programStatus,
    programError,
    uiRequestOverlayType,
    toogleAllOpenButtons,
    isAllOpen,
    setAllOpen,
    onUpdateProgram
}) => {
    const { title, filterType, filterValue } = selection
    const sectionTitle = selectionType === HIGHLIGHT ? ( <Translation id='section_page_only_one_movie_per_week'/>) : ''
    const displayDropzonesClass = displayDropzones ? ' dropzones' : ''
    
    let activeFilterTitle
    let overlay

    if(filterType && filterValue) {
        if(filterType === PERIOD) {
            activeFilterTitle = filterConfig.filterOptions[filterType].filter[filterValue]
        } else {
            activeFilterTitle = filterValue
        } 
    }

    if(programStatus !== requestStatus.REQUEST_SUCCESS && uiRequestOverlayType) {
        overlay = <RequestOverlayContainer 
            programStatus={programStatus}
            programError={programError}
        />
    } else {
        overlay = <OverlayEditSelectionContainer />
    }

    return (
        <WrapperPageEditSelectionTitleContainer
            pageTitle={title}
            overlay = {overlay}
            closePagePath={closePagePath}
            id={selectionId}
            type={selectionType}
            canEdit={true}
        >
            <div className="program-page program-page-edit-selection site-content">
                {activeFilterTitle && <p className="filter-title title-large-light"><Translation id="section_page_active_filter" />: <Translation id={activeFilterTitle}>{activeFilterTitle}</Translation></p>}
                
                <div className="selections-item">
                    <div className="selections-item-content accordion-item">

                            {/* <EditFilter
                                filterType={filterType}
                                filterValue={filterValue}
                            /> */}

                            <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort"/>{sectionTitle}</p>

                        <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                            {toogleAllOpenButtons && <ListToogleAllButtons
                                setAllOpen={setAllOpen}
                            />}
                            
                            <Program
                                displayMovies={displayMovies}
                                displayAds={displayAds}
                                displayAdvertisements={displayAdvertisements}
                                displayHighlights={displayHighlights}
                                displayWeischer={displayWeischer}
                                isAllOpen={isAllOpen}
                                setAllOpen={setAllOpen}
                            />
                        </div>

                        <div className={"selections-item-periodes section-right" + displayDropzonesClass}>
                            <CollectionsListContainer 
                                selectionID={selectionId}
                                selectionType={selectionType}
                                filterValue={filterValue}
                                filterType={filterType}
                            />
                        </div>
                    </div>

                    <div className="save-program-button">
                        <SaveStateButton
                            status={programStatus}
                            transId="publish_program_button"
                            condition={true}
                            saveState={onUpdateProgram}
                        />
                    </div>
                </div>
            </div>
        </WrapperPageEditSelectionTitleContainer>
    )
}

export default SelectionPage